<template>
  <div class="tmr">
    <div v-if="deliveryDay" class="tmr-delivery">
      <span class="tmr-delivery-label">Entrega comprometida</span>
      <strong class="tmr-delivery-day">{{ deliveryDay }}</strong>
    </div>

    <div v-if="order.items.length" class="tmr-order">
      <p class="tmr-title">Materiales del pedido</p>
      <ul class="tmr-items">
        <li v-for="(item, index) in order.items" :key="index" class="tmr-item">
          <span class="tmr-item-name">{{ item.name }}</span>
          <span class="tmr-item-quantity">{{ item.quantity }} {{ item.unit }}</span>
        </li>
      </ul>
      <p v-if="order.note" class="tmr-note"><strong>Nota:</strong> {{ order.note }}</p>
    </div>
    <p v-else-if="order.rawText" class="tmr-raw"><strong>Descripción:</strong> {{ order.rawText }}</p>

    <ticket-materials-evidence v-if="ticket.evidencia_url" :url="ticket.evidencia_url" :ticket-id="ticket.ticket_id" />
  </div>
</template>

<script>
import TicketMaterialsEvidence from './TicketMaterialsEvidence.vue';
import { formatDeliveryDay, parseMaterialsOrderDescription } from './ticketMaterialsReview';

export default {
  name: 'TicketMaterialsReview',
  components: { TicketMaterialsEvidence },
  props: {
    ticket: { type: Object, required: true },
  },
  computed: {
    order() { return parseMaterialsOrderDescription(this.ticket.descripcion); },
    deliveryDay() { return formatDeliveryDay(this.ticket.committed_delivery_date); },
  },
};
</script>

<style scoped>
.tmr { margin-bottom: 8px; }
.tmr-delivery {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #e6f4ec;
  border: 1px solid #d3ecde;
}
.tmr-delivery-label { font-size: 11.5px; font-weight: 600; color: #01662E; text-transform: uppercase; letter-spacing: 0.3px; }
.tmr-delivery-day { font-size: 15px; color: #014d23; }
.tmr-title { margin: 0 0 4px; font-weight: 700; font-size: 12.5px; color: #1f2937; }
.tmr-items { margin: 0; padding: 0; list-style: none; border: 1px solid #eef1ef; border-radius: 10px; }
.tmr-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 10px;
  border-top: 1px solid #eef1ef;
}
.tmr-item:first-child { border-top: none; }
.tmr-item-name { min-width: 0; overflow-wrap: anywhere; }
.tmr-item-quantity { flex-shrink: 0; font-weight: 700; font-variant-numeric: tabular-nums; color: #1f2937; }
.tmr-note { margin: 6px 0 0; white-space: pre-line; }
.tmr-raw { white-space: pre-line; }
</style>
